/* eslint-disable no-unused-expressions */
import { call, delay, fork, put, select, takeLatest } from 'redux-saga/effects';
import { createRatingSuccess, getAllBadgesSuccess, getCriteriabyTaskIdSuccess, getGamificationCriteriaSuccess, getGamificationCriteriaUserSuccess, getMyReviewsSuccess, getReportHistoryByIdSuccess, getReportHistorySuccess, getTradeWorkerPerformanceSuccess, getUnlockedBadges, getUnlockedBadgesSuccess } from "../actions/Rating.Action";
import { CreateRatingApi, GetMyReviewApi, GetReportHistoryApi, GetReportHistoryByIdApi, GetWorkerPerformanceApi, getAllBadgesApi, getAllUnlockedBadgeApi, getCriteriaByTaskId, getGamificationCriteria, getGamificationUserBadges } from '../api';
import { CREATE_RATING, GET_ALL_BADGES, GET_GAMIFICATION_CRITERIA, GET_GAMIFICATION_CRITERIA_USER, GET_MY_RATING, GET_RATING_BY_ID, GET_REPORT_HISTORY, GET_REPORT_HISTORY_BY_ID, GET_UNLOCKED_BADGE, GET_WORKER_PERFORMANCE } from "../storeTypes";
import toast from 'react-hot-toast';

function* getRatingCriteriaSaga(action) {
    try {
        yield put(getCriteriabyTaskIdSuccess([]));
        const response = yield call(getCriteriaByTaskId, action.payload);
        if (response.data.data) {
            yield put(getCriteriabyTaskIdSuccess(response.data.data));

        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        } else {
        }
    }
}
function* createRatingSaga(action) {
    try {
        yield put(createRatingSuccess())
        const response = yield call(CreateRatingApi, action.payload);
        if (response.data.data) {

            console.log('chk29', response);

            yield put(createRatingSuccess(response.data))
            if (response?.status === 200)
                toast.success('Rating saved successfully');
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        }
    }
}

function* getMyReviewSaga(action) {
    try {
        const response = yield call(GetMyReviewApi, action.payload);
        if (response.data.data) {
            yield put(getMyReviewsSuccess(response.data));

        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        }
    }
}

function* getReportHistorySaga(action) {
    try {
        const response = yield call(GetReportHistoryApi, action.payload);
        if (response.data.data) {
            yield put(getReportHistorySuccess(response.data));
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        }
    }
}
function* getReportHistoryByIdSaga(action) {
    try {
        const response = yield call(GetReportHistoryByIdApi, action.payload);
        if (response.data.data) {
            yield put(getReportHistoryByIdSuccess(response.data));
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        }
    }
}
function* getGamificationCriteriaSaga(action) {
    try {
        const response = yield call(getGamificationCriteria, action.payload);
        if (response.data.data) {
            yield put(getGamificationCriteriaSuccess(response.data));
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        }
    }
}
function* getAllBadgesSaga(action) {
    try {
        const response = yield call(getAllBadgesApi, action.payload);
        if (response.data.data) {
            yield put(getAllBadgesSuccess(response.data));
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        }
    }
}
function* getGamificationBadgesUserSaga(action) {
    try {
        const response = yield call(getGamificationUserBadges, action.payload);
        if (response.data.data) {
            yield put(getGamificationCriteriaUserSuccess(response.data));
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        }
    }
}
function* getUnlockedBadgeSaga(action) {
    try {
        const response = yield call(getAllUnlockedBadgeApi, action.payload);
        if (response.data.data) {
            yield put(getUnlockedBadgesSuccess(response.data));
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        }
    }
}
function* getWorkerPerformanceSaga(action) {
    try {
        const response = yield call(GetWorkerPerformanceApi, action.payload);
        if (response.data.data) {
            yield put(getTradeWorkerPerformanceSuccess(response.data));
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        }
    }
}
function* pollUnlockedBadgesSaga() {
    while (true) {
        const { auther } = yield select((state) => state.auth);

        if (auther?._id && auther._id !== "") {
            yield put(getUnlockedBadges());
        }
        else {
            console.log('User is not logged in, skipping API call.');
        }
        yield delay(3600 * 1000); // Delay for 15 minutes
    }
}

export function* RatingsSaga() {
    [
        yield takeLatest(GET_RATING_BY_ID, getRatingCriteriaSaga),
        yield takeLatest(CREATE_RATING, createRatingSaga),
        yield takeLatest(GET_MY_RATING, getMyReviewSaga),
        yield takeLatest(GET_REPORT_HISTORY, getReportHistorySaga),
        yield takeLatest(GET_REPORT_HISTORY_BY_ID, getReportHistoryByIdSaga),
        yield takeLatest(GET_GAMIFICATION_CRITERIA, getGamificationCriteriaSaga),
        yield takeLatest(GET_ALL_BADGES, getAllBadgesSaga),
        yield takeLatest(GET_GAMIFICATION_CRITERIA_USER, getGamificationBadgesUserSaga),
        yield takeLatest(GET_UNLOCKED_BADGE, getUnlockedBadgeSaga),
        yield takeLatest(GET_WORKER_PERFORMANCE, getWorkerPerformanceSaga),
    ];
    yield fork(pollUnlockedBadgesSaga); // Start the polling saga in the background
}
